import { API } from "@/lib/api";
import { ReadAssignmentTypesResponse } from "@/types/assignmentType";

export const fetchAssignmentTypeList =
  async (): Promise<ReadAssignmentTypesResponse> => {
    const response = await fetch(API.StructureAssignmentTypes, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch assignment types: ${response.statusText}`,
      );
    }

    return response.json();
  };
